<template>
  <div class="box">
    <div class="box-yidong" v-if="this.boxyidong">
      <img src="../assets/img/MAP.jpg" alt="" />
      <div id="spin-box-yidong">
        <div style="margin-top: 20px;margin-left: 20px;">
          <b style="color:#fff">{{ `已完成项目` }}</b
          ><el-button
            @click="jiedanye()"
            type="primary"
            size="mini"
            style="float: right;margin-right: 20px;"
            >接单</el-button
          >
        </div>
        <div style="margin-top: 20px;">
          <span class="mingc">区域</span><span class="mingc">面积</span
          ><span class="mingc">类型</span><span class="mingc">日期</span>
        </div>
        <ul id="con1" ref="con1" :class="{ anim: animate == true }">
          <li v-for="(item, i) in items" :key="i">
            <span class="mingc1">{{ item.name }}</span
            ><span class="mingc1">{{ item.mianji }}</span
            ><span class="mingc1">{{ item.leixing }}</span
            ><span class="mingc1">{{ item.shige }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="box1" v-if="this.boxpc">
      <!-- <div class="ditu" ref="mapChart"></div> -->
      <div id="spin-box">
        <div style="margin-top: 20px;margin-left: 20px;">
          <b style="color:#fff">{{ `已完成项目` }}</b
          ><el-button
            @click="jiedanye()"
            type="primary"
            size="mini"
            style="float: right;margin-right: 20px;"
            >接单</el-button
          >
        </div>
        <div style="margin-top: 20px;">
          <span class="mingc">区域</span><span class="mingc">面积</span
          ><span class="mingc">类型</span><span class="mingc">日期</span>
        </div>
        <ul id="con1" ref="con1" :class="{ anim: animate == true }">
          <li v-for="(item, i) in items" :key="i">
            <span class="mingc1">{{ item.name }}</span
            ><span class="mingc1">{{ item.mianji }}</span
            ><span class="mingc1">{{ item.leixing }}</span
            ><span class="mingc1">{{ item.shige }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="fade-box-yidong" ref="scrollOne" v-if="this.boxyidong">
      <div class="w">
        <transition>
          <div class="beijin">
            <img class="beijintu" src="../assets/img/T1(2).png" alt="" />
            <img class="shangjitu" src="../assets/img/T1.png" alt="" />
          </div>
        </transition>
      </div>
    </div>
    <div class="fade-box" ref="scrollOne" v-if="this.boxpc">
      <div class="w">
        <transition name="el-fade-in">
          <div class="beijin" v-show="this.show">
            <img class="beijintu" src="../assets/img/T1(2).png" alt="" />
            <img class="shangjitu" src="../assets/img/T1.png" alt="" />
          </div>
        </transition>
      </div>
    </div>

    <div class="box2">
      <div class="list_box">
        <div class="w">
          <el-col :span="12">
            <img style="height:400px;" src="../assets/img/tt1p.png" alt="" />
          </el-col>
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt1.png" alt="" />
              </li>
              <li class="shuoming">
                国际领先的航空高端传感器系列，包括实景三维航摄仪、高光谱航摄仪、机载双频激光雷达航摄仪。可适配多种无人机和通航有人机，可提供专业级海量数据数据采集服务。泰瑞数据采集业务已连接1000+合作伙伴，覆盖全国238个城市，具备甲级航空数据测绘资质及训练有素的人员队伍，能保障数据采集订单的快速响应。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="caiji()">立即申请</el-button>
              </li>
            </ul>
          </el-col>
        </div>
      </div>
      <div class="list_box1">
        <div class="w">
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt2.png" alt="" />
              </li>
              <li class="shuoming">
                专业计算中心遍布全国多地，拥有上千台计算节点、和生产合作处理中心，可提供各种分辨率类型的数据处理服务，并可对三维模型进行全要素单体化处理。同时，可将物理世界中多源异构多模态空间大数据组织形成室内外语义三维数据。
                数据产品包括城市三维数据、地形三维数据、工业场景数据、自动驾驶场景数据等。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="chuli()">立即申请</el-button>
              </li>
            </ul>
          </el-col>
          <el-col :span="12">
            <img style="height:400px" src="../assets/img/tt2p.png" alt="" />
          </el-col>
        </div>
      </div>
      <div class="list_box">
        <div class="w">
          <el-col :span="12">
            <img style="height:400px;" src="../assets/img/tt3p.png" alt="" />
          </el-col>
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt3.png" alt="" />
              </li>
              <li class="shuoming">
                公司面向智慧城市、工业互联网、智能驾驶三个方向的基础数字孪生产品已全面覆盖各一线城市及数十座二三线城市，解决方案覆盖城市综合治理、社区、园区、交通、公安、应急、能源、水务等30余个细分行业。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="jiejuefangan()"
                  >立即申请</el-button
                >
              </li>
            </ul>
          </el-col>
        </div>
      </div>
      <div class="list_box1">
        <div class="w">
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt4.png" alt="" />
              </li>
              <li class="shuoming">
                泰瑞数创SmartEarth是全产业链数字孪生技术与服务提供商，在此下单可享受从数据采集、数据生产和应用服务的一站式服务。小到社区、园区、工厂、封闭道路，大到城市级、省级、部级，涉及智慧城市、交通、公安、应急、水务等30多个行业，全程无忧，服务到底。
                十五年经验沉淀、上千个项目积累，历练了我们专业、高效、合规的全产业链服务能力。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="yizhanshi()"
                  >立即申请</el-button
                >
              </li>
            </ul>
          </el-col>
          <el-col :span="12">
            <img style="height:400px" src="../assets/img/tt4p.png" alt="" />
          </el-col>
        </div>
      </div>
      <div class="list_box">
        <div class="w">
          <el-col :span="12">
            <img style="height:400px;" src="../assets/img/tt5p.png" alt="" />
          </el-col>
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt5.png" alt="" />
              </li>
              <li class="shuoming">
                与100余各军地空域及有关主管部门保持紧密的沟通与协作，为您提供快速、便捷的空域申请与数据合法化服务。
                本项服务正在筹备上线中。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="kongyu()">立即申请</el-button>
              </li>
            </ul>
          </el-col>
        </div>
      </div>
      <div class="list_box1">
        <div class="w">
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt6.png" alt="" />
              </li>
              <li class="shuoming">
                集合多家保险品牌推出覆盖大飞机及无人机航测的多种航空保险服务，为企业客户提供一站式保险解决方案，目前正在筹备上线中。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="baoxian()"
                  >立即申请</el-button
                >
              </li>
            </ul>
          </el-col>
          <el-col :span="12">
            <img style="height:400px" src="../assets/img/tt6p.png" alt="" />
          </el-col>
        </div>
      </div>
      <div class="list_box">
        <div class="w">
          <el-col :span="12">
            <img style="height:400px;" src="../assets/img/xueyuan.png" alt="" />
          </el-col>
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt7.png" alt="" />
              </li>
              <li class="shuoming">
                定期推出SmartEarth数字孪生系列软件推出直播课，同时集合泰瑞资深技术专家，针对产业链上下游各合作伙伴推出面向智慧城市、工业互联网、智能驾驶三大领域各细分行业的精品小班课。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="xueyuan()"
                  >立即进入</el-button
                >
              </li>
            </ul>
          </el-col>
        </div>
      </div>
      <div class="list_box1">
        <div class="w">
          <el-col :span="12">
            <ul>
              <li class="timu clearfix">
                <img src="../assets/img/tt8.png" alt="" />
              </li>
              <li class="shuoming">
                SmartEarth时空大数据重建工具，可以进行三维地形重建、城市级海量数据实景三维重建、实景三维数据单体化、语义化。可视化管理支持模型的检索、定位、浏览，多源数据集成管理与可视化交互编辑。
              </li>
              <li class="anniu">
                <el-button type="primary" @click="ruanjian()"
                  >立即进入</el-button
                >
              </li>
            </ul>
          </el-col>
          <el-col :span="12">
            <img
              style="height:400px"
              src="../assets/img/ruanjianzhongxing.png"
              alt=""
            />
          </el-col>
        </div>
      </div>
    </div>
    <div class="second_footer">
      <div class="w">
        <div class="hezuobiaoti">
          <img src="../assets/img/T2.png" alt="" />
        </div>
        <div class="hezuogongsi">
          <img src="../assets/img/dibuLOGO.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import echarts from "echarts";
// import "echarts/map/js/china";
// import "echarts/theme/shine.js";

export default {
  //import引入的组件需要注入到对象中才能使用

  data() {
    //这里存放数据
    return {
      boxpc: true,
      boxyidong: false,
      token: window.sessionStorage.getItem("userId"),
      show: false,
      animate: false,
      items: [],
      testData: {},
      imgUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      username: ""
    };
  },
  computed: {
    reversedMessage: function() {
      return this.username.replace(/(^\d{3}|\d{4}\B)/g, "$1-");
    }
  },
  //方法集合
  methods: {
    // async shouyeLest() {
    //   this.$http.interceptors.request.use(
    //     function(config) {
    //       console.log(config);
    //       return config;
    //     },
    //     function(ereor) {
    //       // console.log(ereor);
    //       return Promise.reject(ereor);
    //     }
    //   );
    //   const { data: dt } = await this.$http.post("order/queryOrderList");
    //   console.log(dt);
    // },
    jiedanye() {
      this.$router.push("/userTab");
    },
    ruanjian() {
      this.$router.push("/softwareCenter");
    },
    xueyuan() {
      this.$router.push("/taiRuiCollege");
    },
    baoxian() {
      this.$message("程序猿正在快马加鞭的开发中！！");
    },
    kongyu() {
      this.$message("程序猿正在快马加鞭的开发中！！");
    },
    yizhanshi() {
      this.$router.push("/acquisitionProcessing");
    },
    jiejuefangan() {
      this.$router.push("/solution");
    },
    chuli() {
      this.$router.push("/dataProcess");
    },
    caiji() {
      this.$router.push("/dataCollection");
    },

    handleCommand(command) {
      if (command == 1) {
        this.$router.push("/users");
      } else if (command == 2) {
        this.$confirm("确认要退出系统么?", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("userId");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/index");
            this.$router.go(0);
          })
          .catch(() => {});
      }
    },
    handleScroll() {
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 100
      ) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
        this.items.push(this.items[0]); // 将数组的第一个元素添加到数组的
        this.items.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 500);
    },
    //登陆传输data
    async getRouterData() {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };

      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );

      if (dt.status == 500) {
        this.$confirm("身份认证过期请重新登陆", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("token");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/login");
          })
          .catch(() => {});
        // return this.$message.error("身份认证过期请重新登陆");
      }

      this.testData = dt.data;
      this.username = this.testData.username;
      this.testData.data = JSON.parse(this.testData.data);
      // console.log(this.testData);
      if (this.testData.hasOwnProperty("data")) {
        if (this.testData.data.hasOwnProperty("userhead")) {
          this.imgUrl =
            this.$http.defaults.baseURL +
            "file" +
            "/" +
            this.testData.data.userhead;
        }
      }

      // if (this.testData.type == 0) {

      // }
    }
  },

  created() {
    // this.shouyeLest();
    setInterval(this.scroll, 1500);
    if (this.token !== null) {
      this.getRouterData();
    }
    // 判断是什么端进入
    if (
      /AppleWebKit.*mobile/i.test(navigator.userAgent) ||
      /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(
        navigator.userAgent
      )
    ) {
      if (window.location.href.indexOf("?mobile") < 0) {
        try {
          if (
            /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
          ) {
            //window.location.href = "手机页面";
            this.boxpc = false;
            this.boxyidong = true;
          } else if (/iPad/i.test(navigator.userAgent)) {
            //window.location.href = "平板页面";
            this.boxpc = false;
            this.boxyidong = true;
          } else {
            //window.location.href = "其他移动端页面"
            this.boxpc = false;
            this.boxyidong = true;
          }
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      this.boxpc = true;
      this.boxyidong = false;
    }
    this.items = PROJECT_JSON;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类

.mingc {
  display: inline-block;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  width: 90px;
  text-align: center;
}
.mingc1 {
  display: inline-block;
  color: #fff;
  font-size: 14px;

  width: 90px;
  text-align: center;
}
#spin-box-yidong {
  width: 360px;
  height: 470px;
  overflow: hidden;
  // padding-left: 20px;
  // box-sizing: border-box;
  background-color: rgba(0, 136, 255, 0.3);
  border: 1px solid rgba(0, 136, 255);
  position: absolute;
  z-index: 1000;
  top: 150px;
  left: 100px;
}
#spin-box {
  width: 360px;
  height: 470px;
  overflow: hidden;
  // padding-left: 20px;
  // box-sizing: border-box;
  background-color: rgba(0, 136, 255, 0.3);
  border: 1px solid rgba(0, 136, 255);
  position: absolute;
  z-index: 1000;
  top: 2%;
  left: 5%;
}
.anim {
  transition: all 0.5s;
  margin-top: -30px;
}
#con1 {
  // margin-left: 30px;
  margin-top: 20px;
}
#con1 li {
  list-style: none;
  line-height: 30px;
  height: 30px;
}
.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
.fade-box-yidong {
  height: 150px;
  background-color: rgba(245, 245, 245);
  .beijin {
    width: 100%;
    height: 100%;
    // background: url("../assets/img/T1(2).png");
    // background-repeat: no-repeat;
    // background-size: contain;
    position: relative;
    .beijintu {
      width: 100%;
      height: 100%;
    }
    .shangjitu {
      // width: 100px;
      // height: 280px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(-47%);
    }
  }
}
.fade-box {
  height: 150px;
  background-color: rgba(245, 245, 245);
  .beijin {
    width: 100%;
    height: 100%;
    background: url("../assets/img/T1(2).png");
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    .beijintu {
      width: 100%;
      height: 100%;
    }
    .shangjitu {
      // width: 100px;
      // height: 280px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(-47%);
    }
  }
}
.router-link-active {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
li {
  list-style-type: none;
}
ul {
  margin: 0;
  padding: 0;
}

.second_footer {
  background-color: #021c35;
  .hezuogongsi {
    padding-bottom: 60px;
    img {
      width: 100%;
    }
  }
  .hezuobiaoti {
    width: 100%;
    text-align: center;
    padding-bottom: 80px;
    padding-top: 150px;
    // img {
    //   width: 100%;
    // }
  }
}

.bot_footer {
  background-color: #021325;
  a {
    text-decoration: none;
    color: #fff;
    font-size: 14px;
  }
  ul {
    padding-bottom: 100px;
    padding-top: 100px;

    li {
      color: #fff;
      font-size: 14px;
    }
  }
}
/* 版心 */
.w {
  width: 1190px;
  margin: 0 auto;
}

.box-yidong {
  width: 100%;
  position: relative;
  background-color: rgb(4, 75, 141);
  img {
    width: 100%;

    display: block;
  }
}
.box1 {
  width: 100%;
  height: 100vh;
  position: relative;
  .ditu {
    width: 100%;
    height: 100%;
  }

  background: url("../assets/img/MAP1.jpg") no-repeat top center;

  background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
}
.box2 {
  width: 100%;

  background-color: rgba(245, 245, 245);
  padding-top: 110px;
  padding-bottom: 100px;
  .list_box {
    height: 460px;
    background-color: #fff;
    margin-bottom: 40px;
    li {
      padding-right: 60px;
      box-sizing: border-box;
      font-size: 14px;
    }
    .timu {
      height: 65px;
      margin-top: 80px;
      margin-bottom: 60px;
      img {
        float: right;
      }
    }
    .shuoming {
      margin-bottom: 50px;
    }
    .anniu {
      float: right;
    }
  }
  .list_box1 {
    height: 460px;
    background-color: #fff;
    margin-bottom: 40px;
    li {
      padding-left: 40px;
      box-sizing: border-box;
      font-size: 14px;
    }
    .timu {
      height: 65px;
      margin-top: 80px;
      margin-bottom: 60px;
      // img {
      //   float: right;
      // }
    }
    .shuoming {
      margin-bottom: 50px;
    }
    // .anniu {
    //   float: right;
    // }
  }
}
</style>
